/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

// Scan In, Scan Out

import { Link } from "react-router-dom";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import Alert from "../Alert";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import FormLabel from "../FormLabel";
import Tick from "../Tick";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import L from "../Lang";
import Icon from "../Icon";
import { Pop } from "../PopModal";

class ScanQueue extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            scan: {},
            scanHistory: []
        };
    }

    async componentDidMount() {
        super.componentDidMount();
        await this.load();
    }

    load = async () => {
        await this.fillListAsync('/api/purchase-order/list/out/0', 'purchaseOrders');
    }

    change = (e, resetPO) => {
        let info = { ...this.state.info };
        if (resetPO)
            info.purchaseOrderID = null;
        this.setState({ info: info });
    }

    scan = async (v, force) => {
        this.setState({ scannedItem: null, errorMessage: null });
        if (!v || v.length < 2)
            return;
        try {
            let j = await qreq.postAsync('/api/inventory/scan' + (force ? '?force=true' : ''), {
                accountID: Number(this.state.po.shipToAccountID),
                lotNumber: v,
                in: false,
                out: true,
                purchaseOrderID: this.state.po.id
            });
            if (j.errorCode === 11) {
                Pop.showConfirm(<>{j.errorMessage}<br /><L>Are you sure you want to scan it out on this one? It will remove it from the previous one.</L></>, <L>Item exists in other Packing Slip</L>, () => {
                    this.scan(v, true);
                });
            }
            else if (j.item) {
                let scanHistory = [...this.state.scanHistory];
                j.item.scanDate = new Date();
                scanHistory.unshift(j.item);
                this.setState({ scan: {}, scannedItem: j.item, scanHistory: scanHistory });
                await this.checkPS();
            }
            else {
                this.setState({ errorMessage: j.errorMessage });
            }
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    checkScan = async () => {
        if (this.state.scan?.barcode !== this.currentScan) {
            this.currentScan = this.state.scan?.barcode;
            await this.scan(this.state.scan.barcode);
        }
    }

    checkPS = async (poID) => {
        if (!poID)
            poID = this.state.po.id;
        try {
            let j = await qreq.getAsync('/api/package-slip/scanned/po/' + poID);
            if (j.item) {
                this.setState({ ps: j.item, scanHistory: j.item.items });
            }
        }
        catch (e) {
            console.error(e);
        }
    }


    selectPO = (po) => {
        this.setState({ po: po });
        this.checkPS(po.id);
    }

    getPSItemsCount = () => {
        if (!this.state.ps)
            return 0;
        return this.state.ps.items.length;
    }


    getPSItemsScannedCount = () => {
        if (!this.state.ps)
            return 0;
        return this.state.ps.items.filter(x => x.lotNumber).length;
    }

    getGroupItems = () => {
        if (!this.state.ps?.items) return [];
        let a = Object.groupBy(this.state.ps.items, (item) => {
            return item.catalogCode;
        });

        let b = [];

        for (let k in a) {
            let c = 0;
            a[k].forEach(i => {
                if (i.lotNumber)
                    c++;
            });

            b.push({ name: k, counter: a[k].length, filled: c });
        }

        return b;
    }

    isFilled = () => {
        return this.state.ps && this.getPSItemsScannedCount() >= this.getPSItemsCount();
    }

    undo = async (item) => {
        try {
            let j = await qreq.postAsync('/api/inventory/scan/undo', item);
            if (j.errorCode === 0)
                this.checkPS();
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    showUndo = (item) => {
        Pop.showConfirm(<><L>Are you sure you want to undo:</L> {item.lotNumber}</>, <L>Undo</L>, () => {
            this.undo(item);
        });
    }


    itemExpirationDateClickEdit = (item) => {
        item.__expirationDate = Globals.toMDYLocalDateString(item.expirationDate);
        item.__editExp = true;
        this.setState({ scanHistory: [...this.state.scanHistory] });
    }

    onChangeExpirationDate = (item, e) => {
        item.__expirationDate = e.target.value;
        this.setState({ scanHistory: [...this.state.scanHistory] });
    }

    saveExpirationDate = async (e, item) => {
        e?.preventDefault();
        try {
            let dt = null;
            try {
                dt = new Date(Date.parse(item.__expirationDate));
            }
            catch {
                this.alert('Invalid date input.');
                return;
            }
            let j = await qreq.postAsync('/api/inventory/modify-expiration-date', { ...item, expirationDate: dt });
            if (j.errorCode === 0) {
                this.success('Saved!');
                this.checkPS();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Scan Out</L></h1>

                {!this.state.po ? <>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th><L>Submitted</L></th>
                                <th><L>PO</L></th>
                                <th><L>Bill To</L></th>
                                <th className="d-none d-md-table-cell"><L>Ship To</L></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.purchaseOrders?.map((po, idx) => <tr key={idx} role="button"
                                onClick={() => this.selectPO(po)}>
                                <td className="text-primary">{Globals.toMDYHMLocalDateStringOrDiff(po.sentDate)}</td>
                                <td className="text-primary">{po.iid}</td>
                                <td>{po.accountName}</td>
                                <td className="d-none d-md-table-cell">{po.shipToAccountName}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </>

                    : <>
                        <AppActions onBack={() => this.setState({ po: null, scanHistory: null })} />
                        <Card title="Scan"
                            headerButtons={<>
                                <button className="btn btn-secondary" onClick={() => this.setState({ po: null, scanHistory: null })}>Go Back</button>
                            </>}>
                            <FormLabel label="PO" model={this.state.po.iid} link={'/purchase-order/edit/' + this.state.po.id} />
                            <FormLabel label="Bill To" model={this.state.po.accountName} />
                            <FormLabel label="Ship To" model={this.state.po.shipToAccountName} />

                            <div className="d-flex mb-3">
                                {this.getGroupItems()?.map((i, idx) => <div key={idx} className={'p-3 rounded-1 bg-white me-1 text-center' + (i.filled === i.counter ? ' bg-success' : '')}>
                                    <div>{i.name}</div>
                                    <div className="fs-2"><span>{i.filled}</span><span className="text-muted">/{i.counter}</span></div>
                                </div>)}
                            </div>

                            {this.isFilled() ? <div>
                                <Link to={'/package-slip/po/' + this.state.po.id}><L>Order filled! Continue to Package Slip.</L></Link>
                            </div> : <FormInput
                                model={this.state.scan}
                                label="Scan Barcode Below"
                                name="barcode"
                                placeholder="Activate this input before scanning..."
                                disabled={this.isFilled()}
                                inputClassName="p-2 form-control-lg"
                                autoFocus
                            />}

                        </Card>
                    </>}

                <Tick onTick={this.checkScan} />
                {this.state.errorMessage && <Alert type="danger" message={this.state.errorMessage} />}
                {this.state.scanHistory?.length > 0 && <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th><L>Manufacturer</L></th>
                            <th><L>Product</L></th>
                            <th><L>Size</L></th>
                            <th><L>Catalog Code</L></th>
                            <th><L>Lot Number</L></th>
                            <th><L>Expiration Date</L></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.scanHistory.map((item, idx) => <tr key={idx}>
                            <td>{item.manufacturerName}</td>
                            <td>{item.productName}</td>
                            <td>{item.isPricePerUnit ? item.productSize : 'Standard'}</td>
                            <td>{item.catalogCode}</td>
                            <td>{item.lotNumber}</td>
                            <td>
                                {!item.__editExp ? <>
                                    {Globals.toMDYLocalDateString(item.expirationDate)}

                                    <span className="ms-1" onClick={() => this.itemExpirationDateClickEdit(item)}>
                                        <Icon icon="faEdit" />
                                    </span>
                                </> : <form onSubmit={(e) => this.saveExpirationDate(e, item)} className="d-flex">
                                    <input
                                        value={item.__expirationDate}
                                        onChange={(e) => this.onChangeExpirationDate(item, e)}
                                        className="form-control flex-fill"
                                    />
                                    <button type="submit" className="btn btn-success">
                                        <Icon icon="faSave" />
                                    </button>
                                </form>}
                            </td>
                            <td>
                                {item.lotNumber && <button type="button" className="btn btn-danger" onClick={() => this.showUndo(item)}>
                                    <Icon icon="faUndo" />
                                </button>}
                            </td>
                        </tr>)}
                    </tbody>
                </table>}

            </div>
        );
    }
}

export default withParamsAndNavigate(ScanQueue);